import Cookies from "js-cookie";
import { COOKIES_AUTH_EXPIRES } from "app/constants";

export const AUTH_OPERATOR = "AUTH_OPERATOR";

export const authOperator = ({ uuid, email, shop, token, agentToken, partnerCode }) => {
	try {
		Cookies.set("partner", partnerCode, { path: `/${shop}` });
		Cookies.set("authToken", token, {
			expires: COOKIES_AUTH_EXPIRES,
			path: `/${shop}`,
		});
		Cookies.set("auth", "auth", { expires: COOKIES_AUTH_EXPIRES, path: `/${shop}` });
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error("Error setting cookies in authOperator:", error);
	}
	return {
		type: AUTH_OPERATOR,
		uuid,
		email,
		shop,
		token,
		agentToken,
		partnerCode,
	};
};
